import posthog from 'posthog-js'

/** Same EU project as the mobile app (see noor-app app/src/config/posthog.ts). */
export const NOOR_POSTHOG_PROJECT_ID = '182186'
export const NOOR_POSTHOG_PROJECT_NAME = 'Noor App'

const DEFAULT_HOST = 'https://eu.i.posthog.com'

const apiKey =
  process.env.REACT_APP_POSTHOG_KEY?.trim() ||
  process.env.REACT_APP_POSTHOG_API_KEY?.trim()

const host = process.env.REACT_APP_POSTHOG_HOST?.trim() || DEFAULT_HOST

export const isPostHogConfigured = Boolean(apiKey)

if (isPostHogConfigured && typeof window !== 'undefined') {
  posthog.init(apiKey, {
    api_host: host,
    capture_pageview: false,
    capture_pageleave: true,
    persistence: 'localStorage+cookie',
    autocapture: true,
  })

  posthog.register({
    site: 'noor-website',
    app_name: 'Noor Website',
    posthog_project_id: NOOR_POSTHOG_PROJECT_ID,
    posthog_project_name: NOOR_POSTHOG_PROJECT_NAME,
  })
}

export { posthog }
